<template>
  <div class="upload-project-logo" v-loading="loading">
    <el-upload
      class="logo-uploader"
      :auto-upload="true"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :on-change="uploadChange"
      :action="actionUpload"
      drag
      accept=".png,.jpg,.jpeg"
      :headers="headerUpload"
      name="logo"
      :disabled="readonly"
    >
      <img v-if="imageUrl" class="logo" :src="imageUrl" />
      <div v-else>
        <i class="el-icon-picture logo-uploader-icon"></i>
        <div class="el-upload__text">
          Drop file here or <em>click to upload logo</em>
        </div>
      </div>
    </el-upload>
    <el-button
      v-if="imageUrl && !readonly"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      circle
      @click="deleteLogo"
    ></el-button>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { getLogo, removeLogo } from "@/api/project";
export default {
  props: {
    projectUID: String
  },
  computed: {
    readonly() {
      return this.roleAuth([this.role.admin]);
    }
  },
  data() {
    return {
      loading: false,
      imageUrl: "",
      actionUpload: `${process.env.VUE_APP_SERVER_BASE_API}/api/projects/${
        this.projectUID
      }/logo`,
      headerUpload: {
        authorization: getToken()
      }
    };
  },
  methods: {
    loadLogo() {
      this.loading = true;
      getLogo(this.projectUID).then(data => {
        this.loading = false;
        if (data.byteLength > 60) {
          let image = Buffer.from(data).toString("base64");
          this.imageUrl = image ? `data:image/png;base64, ${image}` : "";
        }
      });
    },
    uploadSuccess(res, file) {
      if (res.result) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    uploadChange(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    deleteLogo() {
      this.$confirm(
        "Are you sure you want to delete Logo, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      ).then(() => {
        removeLogo(this.projectUID).then(({ result, message }) => {
          if (result) {
            this.imageUrl = "";
            this.$message.success(message);
          } else {
            this.$message.error(message);
          }
        });
      });
    }
  },
  mounted() {
    this.loadLogo();
  }
};
</script>

<style lang="scss" scoped>
.upload-project-logo {
  text-align: center;
  border: 1px dashed #606266;
  .logo-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .logo-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .logo-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .logo {
    width: 178px;
    height: auto;
  }
  .el-upload__text {
    color: #606266;
    font-size: 12px;
    text-align: center;
  }
}
</style>

